import { render, staticRenderFns } from "./ConfigurationAnswersList.vue?vue&type=template&id=0ebcf605&"
import script from "./ConfigurationAnswersList.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationAnswersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports